import React, {Component} from 'react'
import {Provider} from 'react-redux'
import {HashRouter, BrowserRouter, Route} from 'react-router-dom'
import configureStore from '../store/configureStore'
import AsyncApp from './AsyncApp'
import {loadUser, OidcProvider} from "redux-oidc";
import userManager from "../utils/userManager";
import {ThemeProvider} from "@material-ui/styles";
import theme from '../theme/theme';
import CallbackPage from '../components/security/callback';


export const store = configureStore()
loadUser(store, userManager);

const isCallback = window.location.pathname === '/callback';

// <Provider> binds react to redux
export default class Root extends Component {
    render() {
        return (
            <Provider store={store} >
                <OidcProvider store={store} userManager={userManager}>
                    <ThemeProvider theme={theme}>
                        {isCallback ? (
                            <BrowserRouter>
                                <Route path="/callback" component={CallbackPage} />
                            </BrowserRouter>
                        ) : (
                            <HashRouter>
                                <AsyncApp/>
                            </HashRouter>
                        )}
                    </ThemeProvider>
                </OidcProvider>
            </Provider>
        )
    }
}
